import { hasGreenStar, sanitizeHandle } from "@/lib/profile"

type UsernameMarkProps = {
  username?: string
  displayName?: string
  userId?: string
  prefix?: boolean
  fallback?: string
  className?: string
}

export default function UsernameMark({
  username,
  displayName,
  userId,
  prefix = true,
  fallback = "collector",
  className = "",
}: UsernameMarkProps) {
  const handle = sanitizeHandle(username || "")
  const label = handle || fallback
  const official = hasGreenStar({ userId, username: handle, displayName })

  return (
    <span className={`inline-flex max-w-full items-center gap-1 ${className}`}>
      <span className="truncate">{prefix ? `@${label}` : label}</span>
      {official ? <OfficialStar /> : null}
    </span>
  )
}

export function OfficialStar() {
  return (
    <span
      title="Official KLIPO account"
      aria-label="Official KLIPO account"
      className="inline-flex shrink-0 text-[#00C805]"
    >
      <svg viewBox="0 0 20 20" className="h-3.5 w-3.5" fill="currentColor" aria-hidden="true">
        <path d="M10 1.6l2.18 4.84 5.32.58-4 3.72.94 5.26L10 13.7 5.56 16l.94-5.26-4-3.72 5.32-.58L10 1.6z" />
      </svg>
    </span>
  )
}
